const SAVE_POSTING_TAG = 'avisos/reservation/SAVE_POSTING_TAG';
const SAVE_POSTING_TAG_COMPLETED = 'avisos/reservation/SAVE_POSTING_TAG_COMPLETED';
const SAVE_POSTING_TAG_FAILED = 'avisos/reservation/SAVE_POSTING_TAG_FAILED';

export { SAVE_POSTING_TAG, SAVE_POSTING_TAG_COMPLETED, SAVE_POSTING_TAG_FAILED };
